import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Camera, Images } from "lucide-react";
import { api, mediaUrl, errMsg } from "@/lib/galleryApi";
import { RetryImg } from "@/components/gallery/RetryImg";
import { PhaseBadge, timeLeft } from "@/components/gallery/retentionUi";

// Organisation admins / event managers: published galleries of their organisation, read-only
export function ClientGalleriesList() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/client/galleries").then(setItems).catch((e) => { toast.error(errMsg(e)); setItems([]); }); }, []);
  return (
    <div className="min-h-screen bg-[#060B14] text-white" data-testid="client-galleries-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-10">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#0099CC] font-semibold mb-2">Photos de vos evenements</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Galeries</h1>
        <p className="text-[#64748B] text-sm mt-2 mb-8 max-w-xl">Consultez les photos livrees par GLOTECH, choisissez vos favorites, telechargez-les et partagez votre galerie.</p>
        {items === null ? (
          <div className="flex justify-center py-24"><div className="w-8 h-8 border-2 border-[#0099CC]/30 border-t-[#0099CC] rounded-full animate-spin" /></div>
        ) : items.length === 0 ? (
          <div className="border border-dashed border-[#1A2332] rounded-2xl py-20 text-center" data-testid="client-galleries-empty">
            <Camera className="w-12 h-12 text-[#1A2332] mx-auto mb-4" />
            <p className="text-sm text-[#94A3B8]">Aucune galerie publiee pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((g) => (
              <button key={g.id} onClick={() => navigate(`/app/galeries/${g.id}`)} className="group text-left bg-[#0B1120] border border-[#1A2332] rounded-xl overflow-hidden hover:border-[#0099CC]/50 transition-colors" data-testid={`client-gallery-card-${g.id}`}>
                <div className="relative aspect-[16/10] bg-[#080E1A] overflow-hidden">
                  {g.cover_url ? <RetryImg src={mediaUrl(g.cover_url)} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" /> : <Camera className="w-10 h-10 text-[#1A2332] absolute inset-0 m-auto" />}
                </div>
                <div className="p-4">
                  <h3 className="text-white font-semibold text-sm truncate">{g.title}</h3>
                  <p className="text-xs text-[#64748B] mt-1 flex items-center gap-1"><Images className="w-3 h-3" />{g.photo_count} photos</p>
                  {g.retention && g.retention.phase !== "open" && <div className="mt-2"><PhaseBadge r={g.retention} testId={`client-gallery-phase-${g.id}`} />{g.retention.phase === "active" && <span className="text-[11px] text-[#F59E0B] ml-2">expire dans {timeLeft(g.retention.seconds_left)}</span>}</div>}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
